const assembleVariantPrice = (
	price_varies,
	price_lowest,
	compare_at_price_lowest,
	price_highest,
	compare_at_price_highest,
) => {
	let priceEl = "";

	if (
		document.body.classList.contains("is-customer") &&
		document.body.dataset.cid != 0
	) {
		if (!price_lowest) return "";

		let priceClass = "";

		if (
			compare_at_price_lowest !== null &&
			!Number.isNaN(compare_at_price_lowest)
		) {
			priceClass = "price--on-sale";
		}

		if (price_varies === true) {
			let priceLowestClass = "";
			let priceHighestClass = "";
			if (compare_at_price_lowest > price_lowest) {
				priceLowestClass = "price-range-sale";
			} else {
				priceLowestClass = "price-item--range_regular";
			}
			if (compare_at_price_highest > price_highest) {
				priceHighestClass = "price-range-sale";
			} else {
				priceHighestClass = "price-item--range_regular";
			}
			priceEl = `<div class="price ${priceClass}">
				<div class="price__container">
					<div class="price__range">
						<span class="${priceLowestClass}">
							$${price_lowest.toFixed(2)}
						</span>
						<span> - </span>
						<span class="${priceHighestClass}">
							$${price_highest.toFixed(2)}
						</span>
					</div>
				</div>
			</div>
			`;
		} else {
			priceEl = `<div class="price ${priceClass}">
			<div class="price__container">
				<div class="price__regular">
					<span class="visually-hidden visually-hidden--inline">Regular price</span>
					<span class="price-item--regular">
						$${price_lowest.toFixed(2)}
					</span>
				</div>
				<div class="price__sale">
					<span class="visually-hidden visually-hidden--inline">Regular price</span>
					<span>
						<s class="price-item--regular">${compare_at_price_lowest.toFixed(2)}</s>
					</span>
					<span class="visually-hidden visually-hidden--inline">Sale price</span>
					<span class="price-item--sale price-item--last">
						$${price_lowest.toFixed(2)}
					</span>
				</div>
			</div>
		</div>
		`;
		}
	}

	return priceEl;
};

const displayCollection = (products, variantMetaFields) => {
	if (products.length === 0) {
		return;
	}

	const collectionProductSlider = document.querySelector(
		"#Slider-shop-the-room-products",
	);

	products.forEach((product, index) => {
		const productVariant = product.variants[0];
		let featuredImage = product.images[0];

		if (productVariant.featured_image) {
			featuredImage = productVariant.featured_image;
		}

		// Initialize variables for price calculations
		let price_varies = false;
		let price_lowest = null;
		let compare_at_price_lowest = null;
		let price_highest = null;
		let compare_at_price_highest = null;

		// Get the first variant's prices
		const keys = Object.keys(variantMetaFields[product.id]);
		const firstVariantData =
			variantMetaFields[product.id][keys[0]]?.customer_price_lists;

		if (firstVariantData) {
			const firstVariantEntries = firstVariantData.split(",");
			const firstVariantResult = firstVariantEntries.map((entry) => {
				const [currency, priceList, values] = entry.split(":");
				return {
					currency,
					priceList,
					values,
				};
			});

			// Initialize price variables from the first variant
			for (const item of firstVariantResult) {
				if (
					item.currency === window.customer.currency &&
					item.priceList === window.customer.category
				) {
					const priceData = item.values.split("/");
					price_lowest = Number.parseFloat(priceData[0]);
					compare_at_price_lowest = Number.parseFloat(priceData[1]);
					price_highest = price_lowest;
					compare_at_price_highest = compare_at_price_lowest;
					break;
				}
			}
		}

		// Find the lowest and highest variant prices
		for (const variantId in variantMetaFields[product.id]) {
			if (
				Object.prototype.hasOwnProperty.call(
					variantMetaFields[product.id],
					variantId,
				)
			) {
				const customerPriceList =
					variantMetaFields[product.id][variantId].customer_price_lists;
				const customerPriceListEntries = customerPriceList.split(",");

				for (const entry of customerPriceListEntries) {
					const [currency, priceList, values] = entry.split(":");
					if (
						currency === window.customer.currency &&
						priceList === window.customer.category
					) {
						const [price, compareAtPrice] = values
							.split("/")
							.map(Number.parseFloat);
						if (price_lowest === null || price < price_lowest) {
							price_lowest = price;
							price_varies = true;
						}
						if (
							compare_at_price_lowest === null ||
							compareAtPrice < compare_at_price_lowest
						) {
							compare_at_price_lowest = compareAtPrice;
							price_varies = true;
						}
						if (price_highest === null || price > price_highest) {
							price_highest = price;
							price_varies = true;
						}
						if (
							compare_at_price_highest === null ||
							compareAtPrice > compare_at_price_highest
						) {
							compare_at_price_highest = compareAtPrice;
							price_varies = true;
						}
					}
				}
			}
		}

		const priceEl = assembleVariantPrice(
			price_varies,
			price_lowest,
			compare_at_price_lowest,
			price_highest,
			compare_at_price_highest,
		);

		const variants = product.variants;

		// Obtain variant options
		let variantOptions = [];
		Object.values(product.options).forEach((option) => {
			if (option.name === "Color") {
				variantOptions = option.values.filter(
					(option) => !option.includes("(Preorder)"),
				);
			}
		});
		// Obtain variant color metadata and inject into variant options
		let swatches = "";
		let variantImages = "";
		if (window.variantColorMetadata) {
			const variantColorsArray = Object.entries(window.variantColorMetadata);
			let variantOptionIndex = 0;
			let alreadyRenderedOptions = [];
			variantOptions.forEach((variantOption) => {
				variantColorsArray.forEach((colorMetadata) => {
					const colorMetadataName = colorMetadata[0];
					const colorMetadataValue = colorMetadata[1];
					const colorMetadataNameSplit = colorMetadataName.split("|");
					if (product.id.toString() === colorMetadataNameSplit[0]) {
						if (variantOption === colorMetadataNameSplit[2]) {
							if (alreadyRenderedOptions.includes(variantOption) === false) {
								let variantSku = "";
								let getFirstMatcedVariant = false;
								product.variants.forEach((variant) => {
									if (variant.option1 === variantOption) {
										if (getFirstMatcedVariant === false) {
											variantSku = variant.sku;
											getFirstMatcedVariant = true;
										}
									}
								});
								const colorMetadataValueSplit = colorMetadataValue.split("|");
								if (colorMetadataValueSplit[1] !== "") {
									swatches += `
									<input type="radio" id="${product.id}-Color-${variantOptionIndex}"
										class="swatch-input"
										name="Color"
										value="${variantOption}"
									>
									<label class="color-swatch swatch-image"
										for="${product.id}-Color-${variantOptionIndex}"
										style="background-size: cover; background-image: url('https://sunpan-marketing.myshopify.com/cdn/shop/${colorMetadataValueSplit[1]}?width=60')"
										data-product="${product.id}"
										data-variant="${colorMetadataNameSplit[1]}"
										data-sku="${variantSku}">
										&nbsp;
									</label>
									`;
									variantOptionIndex++;
								} else if (colorMetadataValueSplit[0] !== "") {
									swatches += `
									<input type="radio" id="${product.id}-Color-${variantOptionIndex}"
										class="swatch-input"
										name="Color"
										value="${variantOption}"
									>
									<label class="color-swatch swatch-hex"
										for="${product.id}-Color-${variantOptionIndex}"
										style="background-color: ${colorMetadataValueSplit[0]}"
										data-product="${product.id}"
										data-variant="${colorMetadataNameSplit[1]}"
										data-sku="${variantSku}">
									&nbsp;
									</label>
									`;
									variantOptionIndex++;
								} else {
									swatches += `
										<input type="radio" id="${product.id}-Color-${variantOptionIndex}"
											class="swatch-input"
											name="Color"
											value="${variantOption}"
										>
										<label for="${product.id}-Color-${variantOptionIndex}" data-product="${product.id}" data-variant="${colorMetadataNameSplit[1]}">
											${variantOption}
										</label>
										`;
									variantOptionIndex++;
								}

								// Render variant images
								variants.forEach((variant) => {
									if (variant.id.toString() === colorMetadataNameSplit[1]) {
										variantImages += `
										<img srcset="${variant.featured_image.src}&amp;width=165 165w,${variant.featured_image.src}&amp;width=360 360w,${variant.featured_image.src}&amp;width=533 533w,${variant.featured_image.src}&amp;width=720 720w,${variant.featured_image.src}&amp;width=940 940w,${variant.featured_image.src} 1000w" src="${variant.featured_image.src}&amp;width=533" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="card-product-image motion-reduce" loading="lazy" width="${variant.featured_image.width}" height="${variant.featured_image.height}" data-variant="${variant.id}">
										`;
									}
								});

								alreadyRenderedOptions.push(variantOption);
							}
						}
					}
				});
			});
		}

		// check if there is an image for the product before rendering
		if (product.images.length) {
			let secondProductImageEl = "";

			if (product.images.length > 1) {
				secondProductImageEl = `<img srcset="${product.images[1].src}&amp;width=165 165w,${product.images[1].src}&amp;width=360 360w,${product.images[1].src}&amp;width=533 533w,${product.images[1].src}&amp;width=720 720w,${product.images[1].src}&amp;width=940 940w,${product.images[1].src} 1000w" src="${product.images[1].src}&amp;width=533" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="card-product-image motion-reduce" loading="lazy" width="${product.images[1].width}" height="${product.images[1].height}" data-variant="${productVariant.id}">`;
			}

			let isComProduct = false;
			product.tags.forEach(tag => {
				if (tag.toLowerCase() === 'com') {
					isComProduct = true;
				}
			});

			const newProduct = `<li id="Slide-shop-the-room-products-${index}" class="grid__item slider__slide">
				<a href="/products/${product.handle}" id="StandardCardNoMediaLink-shop-the-room-products-${productVariant.id}" class="full-unstyled-link main-link" aria-label="${product.title}" data-card-handle="/products/${product.handle}">
				<div class="card-wrapper product-card-wrapper product-card-${product.id}">
					<div class="card card--standard card--media" style="--ratio-percent: 100%;">
						<div class="card__inner  ratio" style="--ratio-percent: 100%;">
							<div class="card__media">
								<div class="media media--transparent media--hover-effect">
									<img srcset="${featuredImage.src} ${featuredImage.width}w" src="${featuredImage.src}&amp;width=533" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${product.title}" class="card-product-image motion-reduce" loading="lazy" width="${featuredImage.width}" height="${featuredImage.height}">
									${secondProductImageEl}
									${variantImages}
								</div>
							</div>
							<div class="card__content">
								<div class="card__information">
									<h3 class="card__heading">
										${product.title}
									</h3>
								</div>
								<div class="card__badge bottom right"></div>
							</div>
						</div>
						<div class="card__content">
							<div class="card__information">
								<div class="card-variant--container">
									<form class="variant-options">
										${swatches}
									</form>
								<h3 class="card__heading h3" id="title-shop-the-room-products-${productVariant.id}">
										${product.title}
								</h3>
									<div>
									<div class="product__sku caption-with-letter-spacing--medium">
										<span>SKU:</span><span class="sku">${productVariant.sku}</span>
									</div>
										${window.customer.login && !isComProduct ? priceEl : ""}
									</div>
								</div>
							</div>
							<div class="card__badge bottom right"></div>
						</div>
					</div>
				</div>
				</a>
			</li>`;

			collectionProductSlider.insertAdjacentHTML("beforeend", newProduct);
		}
	});

	// re-init the slider
	const productSlider = document.querySelector("#collection-slider-component");

	if (productSlider) {
		productSlider.resetPages();
	}
};

const getShopifyCollectionByHandle = async (handle) => {
	const response = await fetch(`/collections/${handle}/products.json`);
	const Collection = await response.json();

	const metaFieldDataRaw = await fetch(
		`/collections/${handle}?section_id=shop-the-room-collection-data`,
	);
	const metaFieldDataHtmlString = await metaFieldDataRaw.text();
	const parser = new DOMParser();
	const metaFieldDataHtml = parser.parseFromString(
		metaFieldDataHtmlString,
		"text/html",
	);
	const scriptTag = metaFieldDataHtml.getElementById("variant-metafields-json");
	const jsonData = scriptTag.textContent;
	const variantMetaFields = JSON.parse(jsonData);

	displayCollection(Collection.products, variantMetaFields);

	// update location history
	const strUrl = new URL(window.location);
	strUrl.searchParams.set("cln", handle);
	window.history.replaceState({}, "", strUrl);
};

function updateRoomCollection(cln) {
	const collectionProductSlider = document.querySelector(
		"#Slider-shop-the-room-products",
	);

	if (collectionProductSlider) {
		collectionProductSlider.innerHTML = "&nbsp;";
		return getShopifyCollectionByHandle(cln);
	}
}

function updateSliderIndex(event) {
	const collectionSliderList = document.querySelector(
		"#Slider-shop-the-room-collections",
	);

	if (collectionSliderList) {
		const currentSlideIndex = parseInt(
			collectionSliderList.querySelector(".is-active").dataset.index,
		);
		const lastSlideIndex = parseInt(
			collectionSliderList.querySelector("li:last-child").dataset.index,
		);
		const direction = event.target.dataset.direction;
		let newSlideIndex = 0;

		if (direction == "prev" && currentSlideIndex == 1) {
			return;
		}

		if (direction == "next" && currentSlideIndex == lastSlideIndex) {
			return;
		}

		collectionSliderList.querySelectorAll(".grid__item").forEach((item) => {
			item.classList.remove("is-active");
		});

		if (direction == "prev") {
			newSlideIndex = currentSlideIndex - 1;
		} else {
			newSlideIndex = currentSlideIndex + 1;
		}

		const newSlideItem = collectionSliderList.querySelector(
			`[data-index="${newSlideIndex}"]`,
		);
		newSlideItem.classList.add("is-active");
		const newCollectionHandle = newSlideItem.dataset.collection;
		updateRoomCollection(newCollectionHandle);
		updateProductCards();
	}
}

function updateProductCards() {
	setTimeout(() => {
		/* Display variant images */
		function showVariantImage(ev) {
			const productId = ev.target.getAttribute("data-product");
			const variantId = ev.target.getAttribute("data-variant");
			const variantSku = ev.target.getAttribute("data-sku");

			// loop over all product card images and make them opaque, except for the selected one
			document
				.querySelectorAll(`.product-card-${productId} .card-product-image`)
				.forEach((img) => {
					const imgVariantId = img.dataset.variant;

					if (imgVariantId === variantId) {
						img.classList.remove("image-hover");
						img.classList.add("image-variant-hover");
					} else {
						img.classList.add("image-hover");
						img.classList.remove("image-variant-hover");
					}
				});
			// update the SKU and the anchor link of selected variant
			const productCard = document.querySelector(`.product-card-${productId}`);

			if (productCard) {
				const variantSkuValue = productCard.querySelector(".product__sku .sku");
				const variantLink = productCard.closest(
					".full-unstyled-link.main-link",
				);

				if (variantSkuValue) {
					variantSkuValue.innerHTML = variantSku;
				}

				if (variantLink) {
					const productUrl = variantLink.dataset.cardHandle;
					const variantUrl = productUrl + "?variant=" + variantId;
					variantLink.setAttribute("href", variantUrl);
				}
			}
		}

		function hideVariantImage(ev) {
			const productId = ev.target.dataset.product;
			const variantId = ev.target.dataset.variant;

			// loop over all product card images and make them opaque, except for the selected one
			document
				.querySelectorAll(`.product-card-${productId} .card-product-image)`)
				.forEach((img) => {
					if (img.dataset.secondaryImage) {
						return;
					}

					const imgVariantId = img.dataset.variant;

					if (imgVariantId === variantId) {
						img.classList.remove("image-variant-hover");
					} else {
						img.classList.remove("image-hover");
					}
				});
		}

		document
			.querySelectorAll(".card-variant--container .color-swatch")
			.forEach((card) => {
				card.addEventListener("click", showVariantImage);
				// card.addEventListener('mouseleave', hideVariantImage);
			});

		const cardContent = document.querySelectorAll(".card-variant--container");
		const sliderContent = document.getElementById(
			"Slider-shop-the-room-products",
		);
		sliderContent.style.overflowX = "clip";
		cardContent.forEach((card) => {
			const options = card.querySelectorAll(".variant-options label");
			// // Temporarily disable page scrolling during click operation
			const originalScrollX = window.scrollX; // Store the current scroll position
			const originalScrollY = window.scrollY; // Store the current scroll position

			let selectedOptionExist = false;
			options.forEach((option) => {
				const optionPseudoAfterStyle = getComputedStyle(option, "::after");
				if (
					optionPseudoAfterStyle.borderBottom === `2px solid rgb(70, 69, 69)`
				) {
					option.click();
					selectedOptionExist = true;
				}
			});
			if (selectedOptionExist === false) {
				options[0].click();
			}
			// Re-enable page scrolling after click operation
			window.scrollTo(originalScrollX, originalScrollY);
		});
		sliderContent.style.overflowX = "auto";
	}, 500);
}

const collectionPreviousBtn = document.querySelector(
	"#shop-the-room-collection-previous",
);
const collectionNextBtn = document.querySelector(
	"#shop-the-room-collection-next",
);

if (collectionPreviousBtn && collectionNextBtn) {
	collectionPreviousBtn.addEventListener("click", updateSliderIndex);
	collectionNextBtn.addEventListener("click", updateSliderIndex);
}

/* Display variant images */
function showVariantImage(ev) {
	const productId = ev.target.dataset.product;
	const variantId = ev.target.dataset.variant;
	const variantSku = ev.target.dataset.sku;

	// loop over all product card images and make them opaque, except for the selected one
	document
		.querySelectorAll(`.product-card-${productId} .card-product-image`)
		.forEach((img) => {
			const imgVariantId = img.dataset.variant;

			if (imgVariantId === variantId) {
				img.classList.remove("image-hover");
				img.classList.add("image-variant-hover");
			} else {
				img.classList.add("image-hover");
				img.classList.remove("image-variant-hover");
			}
		});

	// update the SKU and the anchor link of selected variant
	const productCard = document.querySelector(`.product-card-${productId}`);

	if (productCard) {
		const variantSkuValue = productCard.querySelector(".product__sku .sku");
		const variantLink = productCard.closest(
			".full-unstyled-link.main-link",
		);

		if (variantSkuValue) {
			variantSkuValue.innerHTML = variantSku;
		}

		if (variantLink) {
			const productUrl = variantLink.dataset.cardHandle;
			const variantUrl = productUrl + "?variant=" + variantId;
			variantLink.setAttribute("href", variantUrl);
		}
	}
}

function hideVariantImage(ev) {
	const productId = ev.target.dataset.product;
	const variantId = ev.target.dataset.variant;

	// loop over all product card images and make them opaque, except for the selected one
	document
		.querySelectorAll(`.product-card-${productId} .card-product-image)`)
		.forEach((img) => {
			if (img.dataset.secondaryImage) {
				return;
			}

			const imgVariantId = img.dataset.variant;

			if (imgVariantId === variantId) {
				img.classList.remove("image-variant-hover");
			} else {
				img.classList.remove("image-hover");
			}
		});
}

document
	.querySelectorAll(".card-variant--container .color-swatch")
	.forEach((card) => {
		card.addEventListener("click", showVariantImage);
		// card.addEventListener('mouseleave', hideVariantImage);
	});

/* Init first variant option is selected */
window.addEventListener("DOMContentLoaded", function () {
	setTimeout(() => {
		const cardContent = document.querySelectorAll(".card-variant--container");
		const sliderContent = document.getElementById(
			"Slider-shop-the-room-products",
		);
		sliderContent.style.overflowX = "clip";
		cardContent.forEach((card) => {
			const options = card.querySelectorAll(".variant-options label");
			// // Temporarily disable page scrolling during click operation
			const originalScrollX = window.scrollX; // Store the current scroll position
			const originalScrollY = window.scrollY; // Store the current scroll position

			let selectedOptionExist = false;
			options.forEach((option) => {
				const optionPseudoAfterStyle = getComputedStyle(option, "::after");
				if (
					optionPseudoAfterStyle.borderBottom === `2px solid rgb(70, 69, 69)`
				) {
					option.click();
					selectedOptionExist = true;
				}
			});
			if (selectedOptionExist === false) {
				options[0].click();
			}
			// Re-enable page scrolling after click operation
			window.scrollTo(originalScrollX, originalScrollY);
		});
		sliderContent.style.overflowX = "auto";
	}, 500);
});
